import React, { useState } from 'react';
import { Typography } from '@mui/material';
import { phoneNumberValidator } from '@persian-tools/persian-tools';

import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { PhoneInput } from '../phone-input';
import LoadingButton from '@mui/lab/LoadingButton';
import { useLoginMutation } from '../../auth.api';

export function PhoneForm(): JSX.Element {
    const navigate = useNavigate();
    const location = useLocation();

    const [phoneValidate, setPhoneValidate] = useState<boolean>(false);
    const [message, setMessage] = useState('لطفا شماره همراه معتبر وارد کنید');
    const [isFirstTime, setisFirstTime] = useState<boolean>(true);

    const [phone, setPhone] =
        useOutletContext<
            [string, React.Dispatch<React.SetStateAction<string>>]
        >();
    const [login, { isLoading }] = useLoginMutation();

    const onSubmitHandler = async () => {
        if (isFirstTime) setisFirstTime(false);

        if (phoneValidate) {
            await login({ phone }).then((res: any) => {
                if (res?.data?.mode) {
                    navigate('/verify', { state: res?.data });
                } else {
                    setPhoneValidate(false);

                    setMessage(
                        res?.error?.data?.message ??
                            'لطفا شماره همراه خود را به درستی وارد کنید',
                    );
                }
            });
        }
    };

    const onChangePhone = (event: {
        target: { name: string; value: string };
    }) => {
        const value = event.target.value.replaceAll(' ', '');
        if (!value.startsWith('0')) {
            setPhoneValidate(false);
            setMessage('فرمت شماره همراه به صورت 09xx xxx xxxx می باشد.');
        } else {
            setPhoneValidate(phoneNumberValidator(value));
            setMessage('لطفا شماره همراه معتبر وارد کنید');
        }
        setPhone(value);
    };

    const { state: currentPhoneNumber } = location;

    return (
        <>
            <Typography
                sx={{
                    marginTop: 1,
                    marginBottom: 1,
                    fontSize: { xs: '18px', sm: '20px' },
                    color: 'text.primary',
                }}
                className="font-yekan-heavy"
                variant="h3"
                component="h1"
            >
                ورود / ثبت‌‌نام
            </Typography>

            <Typography
                component="h4"
                sx={{
                    marginBottom: 3,
                    fontSize: { xs: '13px', sm: '14px' },
                }}
                className="font-sans"
            >
                برای استفاده از خدمات آقای پرداخت با وارد کردن شماره همراه خود،
                وارد حساب کاربری شوید.
            </Typography>

            <PhoneInput
                error={!isFirstTime && !phoneValidate}
                onChange={onChangePhone}
                onKeyDown={(e) => e.key === 'Enter' && onSubmitHandler()}
                value={currentPhoneNumber?.phone}
                label="شماره همراه"
                message={message}
            />

            <LoadingButton
                fullWidth
                loading={isLoading}
                sx={{ marginTop: 4 }}
                onClick={onSubmitHandler}
                variant="contained"
                disabled={!isFirstTime && !phoneValidate}
                className="font-sans"
            >
                تایید و ادامه
            </LoadingButton>
        </>
    );
}
